import VirtualStagingPage from './virtual-staging-page'
export default VirtualStagingPage
